import { FC, useCallback, ChangeEvent, ReactNode } from "react";
import {
  Stack,
  Switch,
  SwitchProps,
  Tooltip,
  Typography,
  TypographyProps,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface SwitchWithTypographyProps {
  checked: boolean;
  title: ReactNode;
  infoTooltipTitle?: string;
  switchProps?: SwitchProps;
  typographyProps?: TypographyProps;
  variant?: "filled" | "bgTransparent";
  onChange: (checked: boolean) => void;
}

export const SwitchWithTypography: FC<SwitchWithTypographyProps> = ({
  title,
  checked,
  onChange,
  switchProps,
  typographyProps,
  infoTooltipTitle,
  variant = "bgTransparent",
}) => {
  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange(checked);
    },
    [onChange],
  );

  return (
    <Stack
      py={0.5}
      spacing={1}
      direction="row"
      alignItems="center"
      sx={variant === "filled" ? filledVariantStyles : undefined}
    >
      <Switch
        checked={checked}
        onChange={handleChange}
        size="small"
        {...switchProps}
      />
      <Typography variant="inherit" {...typographyProps}>
        {title}
      </Typography>

      {infoTooltipTitle && (
        <Tooltip arrow placement="top" title={infoTooltipTitle}>
          <InfoOutlinedIcon fontSize="small" color="action" />
        </Tooltip>
      )}
    </Stack>
  );
};

const filledVariantStyles = { bgcolor: "grey.100", borderRadius: 2 };
